import * as yup from "yup";
import { TFunction } from "i18next";

export interface User {
  name: string;
  email: string;
}

export const UserValidation = (t: TFunction) => {
  return yup.object({
    name: yup.string().required(t("validation.user.name.required")),
    email: yup
      .string()
      .required(t("validation.user.email.required"))
      .max(64, t("validation.user.email.max", { max: 64 }))
      .email(t("validation.user.email.valid"))
  });
};

export const createUser = (name: string = "", email: string = ""): User => ({
  name: name,
  email: email
});
